<template>
    <div class="body">
        <h1 class="has-text-primary is-size-1">Our Products</h1>
        <div class="columns is-centered">
            <div class="product">
                <product-view v-for="prod in products" :product="prod"></product-view>
            </div>
        </div>
    </div>
</template>

<script>
    import BButton from "buefy/src/components/button/Button";
    import ProductView from "./ProductView";
    export default {
        name: "Products",
        components: {ProductView, BButton},
        data() {
            return {
                products: [
                    'sequ-health-pro',
                    'sequ-face',
                    'sequ-doc',
                    'sequ-lab'
                ]
            }
        }
    }
</script>

<style scoped>
    .product {
        padding-left: 6%;
        padding-right: 6%;
        padding-top: 36px;
        padding-bottom: 36px;
        max-width: 1080px;
    }

    h1 {
        text-align: center;
    }
</style>